import { CardContainer } from "@msys/ui";
import { List, ListItemButton, ListItemText } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { Link } from "react-router-dom";
import { Project } from "../../../../clients/graphqlTypes.js";
import { ProjectStatusBadge } from "../../projects/badges/ProjectStatusBadge.js";
import { CreateProjectOrTicketButton } from "../../projects/buttons/CreateProjectOrTicketButton.js";

interface Props {
  projects: Pick<Project, "id" | "title" | "state">[];
  building: React.ComponentProps<
    typeof CreateProjectOrTicketButton
  >["building"];
  buildingItemId: string;
  canAdd?: boolean;
}

export const BuildingProjectsBox = ({
  building,
  buildingItemId,
  projects,
  canAdd = false,
}: Props) => {
  const { t } = useTranslate("Projects");

  return (
    <CardContainer
      title={t("Projects")}
      itemCount={projects.length}
      ActionButton={
        canAdd &&
        buildingItemId && (
          <CreateProjectOrTicketButton
            type="icon"
            size="small"
            building={building}
            buildingItemId={buildingItemId}
            pageName="Building"
          />
        )
      }
    >
      <List disablePadding>
        {projects.map((project, index, array) => (
          <ListItemButton
            key={project.id}
            component={Link}
            divider={index < array.length - 1}
            to={`/projects/${project.id}`}
          >
            <ListItemText primary={project.title} />
            <ProjectStatusBadge projectState={project.state} align="right" />
          </ListItemButton>
        ))}
      </List>
    </CardContainer>
  );
};
